/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import { HcoSummaryFragmentDoc } from './HCOSummary.hook';
import { HcoCoreFragmentDoc } from './HCOCore.hook';
import {
	AddressSummaryFragmentDoc,
	AddressFragmentDoc
} from '../Address/Address.hook';
import { NotFoundErrorFragmentDoc, PaginationFragmentDoc } from '../core.hook';
import {
	ParentAffiliationFragmentDoc,
	AffiliationFragmentDoc
} from '../Affiliation/Affiliation.hook';
import { LicenseFragmentDoc } from '../License/License.hook';
export type HcoFragment = {
	__typename?: 'HCO';
	countryId?: string | null;
	businessType_V?: string | null;
	nhidCda_V?: string | null;
	hcoTaxId_V?: string | null;
	officePhoneCda_V?: string | null;
	faxCda_V?: string | null;
	emailCda_V?: string | null;
	websiteCda_V?: string | null;
	vaDodAffiliated_V?: boolean | null;
	vid_V: string;
	veevaid_V: string;
	statusCda_V?: string | null;
	statusCda_VId?: string | null;
	hcoNameCda_V?: string | null;
	hcoNameShort_V?: string | null;
	hcoNameEnglish_V?: string | null;
	hcoNameIntl_V?: string | null;
	hcoTypeCda_V?: string | null;
	parentInactiveAffiliationCount: number;
	childInactiveAffiliationCount: number;
	localHcoType?: {
		__typename?: 'LocalHCOType';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	hcoHierarchyType?: {
		__typename?: 'HCOHierarchyType';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	hcpCount?: {
		__typename?: 'CountRange';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	prescriberCount?: {
		__typename?: 'CountRange';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	ownership?: {
		__typename?: 'HCOOwnership';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	academicStatus?: {
		__typename?: 'AcademicStatus';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	primaryLocalSpecialty?: {
		__typename?: 'LocalSpecialty';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	secondaryLocalSpecialty?: {
		__typename?: 'LocalSpecialty';
		code: string;
		name: string;
		localizedName?: string | null;
	} | null;
	localSpecialties: Array<{
		__typename?: 'LocalSpecialty';
		code: string;
		name: string;
		localizedName?: string | null;
	}>;
	mainOrganization?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string }
		| null;
	topOrganization?:
		| {
				__typename?: 'HCO';
				vid_V: string;
				veevaid_V: string;
				statusCda_V?: string | null;
				statusCda_VId?: string | null;
				hcoNameCda_V?: string | null;
				hcoNameShort_V?: string | null;
				hcoNameEnglish_V?: string | null;
				hcoNameIntl_V?: string | null;
				hcoTypeCda_V?: string | null;
				addresses: Array<{
					__typename?: 'Address';
					vid_V: string;
					primaryCda_V?: boolean | null;
					cityCda_V?: string | null;
					cityIntl_V?: string | null;
					stateCda_V?: string | null;
					countryCda_V?: string | null;
					streetAddress1Cda_V?: string | null;
					streetAddress1Intl_V?: string | null;
					postalCodeCda_V?: string | null;
					postalCodeIntl_V?: string | null;
				}>;
				hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
		  }
		| { __typename?: 'ResourceNotFound'; message: string }
		| null;
	parentAffiliations: {
		__typename?: 'HCOAffiliationsResults';
		results: Array<{
			__typename?: 'ParentHCO';
			vid_V: string;
			classOfWork_V?: string | null;
			isPrimaryRelationship_V?: boolean | null;
			parentHcoStatus_VId?: string | null;
			childVeevaid_V?: string | null;
			parentVeevaid_V?: string | null;
			jobTitle_V?: string | null;
			parentHco:
				| {
						__typename?: 'HCO';
						officePhoneCda_V?: string | null;
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							streetAddress2Cda_V?: string | null;
							streetAddress2Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
							postalCodeFullUs_V?: string | null;
							cbsa_V?: string | null;
							latitudeCda_V?: number | null;
							longitudeCda_V?: number | null;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							subStateAdminUnit_V?: string | null;
							businessCda_V?: boolean | null;
							dpvConfirmedIndicator_V?: string | null;
							buildingIdentifier_V?: string | null;
							phoneCda_V?: string | null;
							faxCda_V?: string | null;
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							hospitalCampus?:
								| {
										__typename?: 'HCO';
										vid_V: string;
										veevaid_V: string;
										statusCda_V?: string | null;
										statusCda_VId?: string | null;
										hcoNameCda_V?: string | null;
										hcoNameShort_V?: string | null;
										hcoNameEnglish_V?: string | null;
										hcoNameIntl_V?: string | null;
										hcoTypeCda_V?: string | null;
										addresses: Array<{
											__typename?: 'Address';
											vid_V: string;
											primaryCda_V?: boolean | null;
											cityCda_V?: string | null;
											cityIntl_V?: string | null;
											stateCda_V?: string | null;
											countryCda_V?: string | null;
											streetAddress1Cda_V?: string | null;
											streetAddress1Intl_V?: string | null;
											postalCodeCda_V?: string | null;
											postalCodeIntl_V?: string | null;
										}>;
										hcoType?: {
											__typename?: 'HCOType';
											id: string;
											name: string;
										} | null;
								  }
								| { __typename?: 'ResourceNotFound'; message: string }
								| null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string };
			relationshipType?: {
				__typename?: 'RelationshipType';
				code: string;
				name: string;
			} | null;
		}>;
		paginationMetadata: {
			__typename?: 'PaginationMetadata';
			total: number;
			page: number;
			pageSize: number;
			totalPages: number;
		};
	};
	childAffiliations: {
		__typename?: 'HCOAffiliationsResults';
		results: Array<{
			__typename?: 'ParentHCO';
			vid_V: string;
			classOfWork_V?: string | null;
			isPrimaryRelationship_V?: boolean | null;
			parentHcoStatus_VId?: string | null;
			childVeevaid_V?: string | null;
			parentVeevaid_V?: string | null;
			jobTitle_V?: string | null;
			relationshipType?: {
				__typename?: 'RelationshipType';
				code: string;
				name: string;
			} | null;
			parentHco:
				| {
						__typename?: 'HCO';
						officePhoneCda_V?: string | null;
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							streetAddress2Cda_V?: string | null;
							streetAddress2Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
							postalCodeFullUs_V?: string | null;
							cbsa_V?: string | null;
							latitudeCda_V?: number | null;
							longitudeCda_V?: number | null;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							subStateAdminUnit_V?: string | null;
							businessCda_V?: boolean | null;
							dpvConfirmedIndicator_V?: string | null;
							buildingIdentifier_V?: string | null;
							phoneCda_V?: string | null;
							faxCda_V?: string | null;
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							hospitalCampus?:
								| {
										__typename?: 'HCO';
										vid_V: string;
										veevaid_V: string;
										statusCda_V?: string | null;
										statusCda_VId?: string | null;
										hcoNameCda_V?: string | null;
										hcoNameShort_V?: string | null;
										hcoNameEnglish_V?: string | null;
										hcoNameIntl_V?: string | null;
										hcoTypeCda_V?: string | null;
										addresses: Array<{
											__typename?: 'Address';
											vid_V: string;
											primaryCda_V?: boolean | null;
											cityCda_V?: string | null;
											cityIntl_V?: string | null;
											stateCda_V?: string | null;
											countryCda_V?: string | null;
											streetAddress1Cda_V?: string | null;
											streetAddress1Intl_V?: string | null;
											postalCodeCda_V?: string | null;
											postalCodeIntl_V?: string | null;
										}>;
										hcoType?: {
											__typename?: 'HCOType';
											id: string;
											name: string;
										} | null;
								  }
								| { __typename?: 'ResourceNotFound'; message: string }
								| null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string };
			childHco:
				| {
						__typename?: 'HCO';
						officePhoneCda_V?: string | null;
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							streetAddress2Cda_V?: string | null;
							streetAddress2Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
							postalCodeFullUs_V?: string | null;
							cbsa_V?: string | null;
							latitudeCda_V?: number | null;
							longitudeCda_V?: number | null;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							subStateAdminUnit_V?: string | null;
							businessCda_V?: boolean | null;
							dpvConfirmedIndicator_V?: string | null;
							buildingIdentifier_V?: string | null;
							phoneCda_V?: string | null;
							faxCda_V?: string | null;
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							hospitalCampus?:
								| {
										__typename?: 'HCO';
										vid_V: string;
										veevaid_V: string;
										statusCda_V?: string | null;
										statusCda_VId?: string | null;
										hcoNameCda_V?: string | null;
										hcoNameShort_V?: string | null;
										hcoNameEnglish_V?: string | null;
										hcoNameIntl_V?: string | null;
										hcoTypeCda_V?: string | null;
										addresses: Array<{
											__typename?: 'Address';
											vid_V: string;
											primaryCda_V?: boolean | null;
											cityCda_V?: string | null;
											cityIntl_V?: string | null;
											stateCda_V?: string | null;
											countryCda_V?: string | null;
											streetAddress1Cda_V?: string | null;
											streetAddress1Intl_V?: string | null;
											postalCodeCda_V?: string | null;
											postalCodeIntl_V?: string | null;
										}>;
										hcoType?: {
											__typename?: 'HCOType';
											id: string;
											name: string;
										} | null;
								  }
								| { __typename?: 'ResourceNotFound'; message: string }
								| null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string };
		}>;
		paginationMetadata: {
			__typename?: 'PaginationMetadata';
			total: number;
			page: number;
			pageSize: number;
			totalPages: number;
		};
	};
	addresses: Array<{
		__typename?: 'Address';
		streetAddress1Cda_V?: string | null;
		streetAddress1Intl_V?: string | null;
		streetAddress2Cda_V?: string | null;
		streetAddress2Intl_V?: string | null;
		postalCodeCda_V?: string | null;
		postalCodeIntl_V?: string | null;
		postalCodeFullUs_V?: string | null;
		cbsa_V?: string | null;
		latitudeCda_V?: number | null;
		longitudeCda_V?: number | null;
		statusCda_V?: string | null;
		statusCda_VId?: string | null;
		subStateAdminUnit_V?: string | null;
		businessCda_V?: boolean | null;
		dpvConfirmedIndicator_V?: string | null;
		buildingIdentifier_V?: string | null;
		phoneCda_V?: string | null;
		faxCda_V?: string | null;
		vid_V: string;
		primaryCda_V?: boolean | null;
		cityCda_V?: string | null;
		cityIntl_V?: string | null;
		stateCda_V?: string | null;
		countryCda_V?: string | null;
		hospitalCampus?:
			| {
					__typename?: 'HCO';
					vid_V: string;
					veevaid_V: string;
					statusCda_V?: string | null;
					statusCda_VId?: string | null;
					hcoNameCda_V?: string | null;
					hcoNameShort_V?: string | null;
					hcoNameEnglish_V?: string | null;
					hcoNameIntl_V?: string | null;
					hcoTypeCda_V?: string | null;
					addresses: Array<{
						__typename?: 'Address';
						vid_V: string;
						primaryCda_V?: boolean | null;
						cityCda_V?: string | null;
						cityIntl_V?: string | null;
						stateCda_V?: string | null;
						countryCda_V?: string | null;
						streetAddress1Cda_V?: string | null;
						streetAddress1Intl_V?: string | null;
						postalCodeCda_V?: string | null;
						postalCodeIntl_V?: string | null;
					}>;
					hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
			  }
			| { __typename?: 'ResourceNotFound'; message: string }
			| null;
	}>;
	licenses: Array<{
		__typename?: 'License';
		vid_V: string;
		typeValue_VId?: string | null;
		bestStateLicense_V?: boolean | null;
		body_V?: string | null;
		collabAgreeRequired_V?: string | null;
		comprehensivePrescriptiveAuthority_V?: string | null;
		comprehensiveSampleEligibility_V?: string | null;
		ctrlSubstancePrescriptive_V?: string | null;
		ctrlSubstanceSample_V?: string | null;
		deaBusinessActivityCode_V?: string | null;
		deaPaymentIndicator_V?: string | null;
		drugSchedule_V?: string | null;
		expirationDate_V?: any | null;
		gracePeriod_V?: any | null;
		licenseCertification_V?: string | null;
		licenseDegree_V?: string | null;
		licenseEligibility_V?: string | null;
		licenseNumber_V?: string | null;
		licenseStatusCondition_V?: string | null;
		licenseStatus_V?: string | null;
		licenseSubtype_V?: string | null;
		rxaEligible_V?: string | null;
		sourceAddress_V?: string | null;
		type_V?: string | null;
		address?: {
			__typename?: 'Address';
			streetAddress1Cda_V?: string | null;
			streetAddress1Intl_V?: string | null;
			streetAddress2Cda_V?: string | null;
			streetAddress2Intl_V?: string | null;
			postalCodeCda_V?: string | null;
			postalCodeIntl_V?: string | null;
			postalCodeFullUs_V?: string | null;
			cbsa_V?: string | null;
			latitudeCda_V?: number | null;
			longitudeCda_V?: number | null;
			statusCda_V?: string | null;
			statusCda_VId?: string | null;
			subStateAdminUnit_V?: string | null;
			businessCda_V?: boolean | null;
			dpvConfirmedIndicator_V?: string | null;
			buildingIdentifier_V?: string | null;
			phoneCda_V?: string | null;
			faxCda_V?: string | null;
			vid_V: string;
			primaryCda_V?: boolean | null;
			cityCda_V?: string | null;
			cityIntl_V?: string | null;
			stateCda_V?: string | null;
			countryCda_V?: string | null;
			hospitalCampus?:
				| {
						__typename?: 'HCO';
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
				  }
				| { __typename?: 'ResourceNotFound'; message: string }
				| null;
		} | null;
	}>;
	hcoType?: { __typename?: 'HCOType'; id: string; name: string } | null;
};

export const HcoFragmentDoc = gql`
	fragment HCO on HCO {
		...HCOSummary
		countryId
		businessType_V
		nhidCda_V
		hcoTaxId_V
		officePhoneCda_V
		faxCda_V
		emailCda_V
		websiteCda_V
		localHcoType {
			code
			name
			localizedName
		}
		hcoHierarchyType {
			code
			name
			localizedName
		}
		hcpCount {
			code
			name
			localizedName
		}
		prescriberCount {
			code
			name
			localizedName
		}
		ownership {
			code
			name
			localizedName
		}
		academicStatus {
			code
			name
			localizedName
		}
		primaryLocalSpecialty {
			code
			name
			localizedName
		}
		secondaryLocalSpecialty {
			code
			name
			localizedName
		}
		localSpecialties {
			code
			name
			localizedName
		}
		mainOrganization {
			... on HCO {
				...HCOCore
				addresses(includeInactive: true) {
					...AddressSummary
				}
			}
			...NotFoundError
		}
		topOrganization {
			... on HCO {
				...HCOCore
				addresses(includeInactive: true) {
					...AddressSummary
				}
			}
			...NotFoundError
		}
		parentInactiveAffiliationCount: inactiveAffiliationCount(direction: PARENT)
		parentAffiliations: affiliations(
			payload: { includeInactive: false, direction: PARENT }
			paginationInput: { page: 1, pageSize: $affiliationsPageSize }
		) {
			results {
				...ParentAffiliation
			}
			paginationMetadata {
				...Pagination
			}
		}
		childInactiveAffiliationCount: inactiveAffiliationCount(direction: CHILD)
		childAffiliations: affiliations(
			payload: { includeInactive: false, direction: CHILD }
			paginationInput: { page: 1, pageSize: $affiliationsPageSize }
		) {
			results {
				...Affiliation
			}
			paginationMetadata {
				...Pagination
			}
		}
		addresses(includeInactive: true) {
			...Address
		}
		licenses {
			...License
		}
		vaDodAffiliated_V
	}
	${HcoSummaryFragmentDoc}
	${HcoCoreFragmentDoc}
	${AddressSummaryFragmentDoc}
	${NotFoundErrorFragmentDoc}
	${ParentAffiliationFragmentDoc}
	${PaginationFragmentDoc}
	${AffiliationFragmentDoc}
	${AddressFragmentDoc}
	${LicenseFragmentDoc}
`;
